const { showToast } = require("./toast");

const handleErrors = (err) => {
    if (err?.response?.data?.error !== undefined) {
        const errorType = typeof err.response.data.error;

        if (errorType === 'string') {
            showToast('error', err.response.data.error, 'Error');
        } else if (errorType === 'object') {

            let message = "";
            if (Array.isArray(err.response.data.error)) {

                err.response.data.error.forEach((item) => {
                    item = item.replace('"', "").replace('"', "").replace(".", " ").toUpperCase()
                    message += item+'\n'
                })
            } else {
                message = err.response.data.error?.message || 'An unknown error occurred.'
            }

            showToast('error', message || 'An unknown error occurred.', 'Error');
        } else {
            console.log("Unhandled error type:", errorType);
        }
    } else if (err?.response?.data?.message !== undefined) {
        showToast('error', err?.response?.data?.message, 'Error');
    } else if (err?.status) {
        showToast('error', `Request failed with status code ${err.status}`, 'Error');
    } else {
        showToast('error', 'An unexpected error occurred.', 'Error');
    }
};


const formatDate = (isoDate) => {
    if (!isoDate) return '';

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();

    const getOrdinal = (n) => {
        const s = ["th", "st", "nd", "rd"];
        const v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    return `${getOrdinal(day)} ${month} ${year}`;
};

const getRandomRangeBetween = (min, max) => {
    if (min >= max) throw new Error("Min should be less than Max");

    const range = max - min;

    let val1 = Math.floor(Math.random() * range) + min;
    let val2 = Math.floor(Math.random() * range) + min;

    const randomMin = Math.min(val1, val2);
    const randomMax = Math.max(val1, val2);

    return { min: randomMin, max: randomMax };
}


module.exports = {
    formatDate,
    handleErrors,
    getRandomRangeBetween
}